// Import React polyfill FIRST to ensure React is available via require()
import './polyfills/react-require'
import * as React from 'react'
import ReactDOM from 'react-dom/client'

// Ensure React is available globally (polyfill should have done this, but double-check)
if (typeof window !== 'undefined' && !window.React) {
  window.React = React
}
if (typeof globalThis !== 'undefined' && !globalThis.React) {
  globalThis.React = React
}

import { I18nextProvider } from 'react-i18next'
import { initReactI18next } from 'react-i18next'
import './styles/index.css'
import i18n, { resources, LanguageDetector } from './i18n'
import App from './App.jsx'

// Initialize i18n with React plugin AFTER React is loaded and set globally
// This ensures React hooks are available when initReactI18next runs
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      defaultNS: 'translation',
      ns: ['translation'],
      
      // Language detection options
      detection: {
        // Order of detection methods
        order: ['localStorage', 'navigator', 'htmlTag'],
        
        // Keys to lookup language from
        lookupLocalStorage: 'i18nextLng',
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,
        
        // Cache user language
        caches: ['localStorage'],
        
        // Don't cache if language is not detected
        excludeCacheFor: ['cimode'],
      },
      
      // Interpolation options
      interpolation: {
        escapeValue: false, // React already escapes values
        formatSeparator: ',',
      },
      
      // React options
      react: {
        useSuspense: false, // Disable suspense for better compatibility
      },
      
      // Debug mode (set to false in production)
      debug: false,
      
      // Return null if key not found (for development)
      returnNull: false,
      
      // Return empty string if key not found (for production)
      returnEmptyString: false,
    })
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
)

